import Navigation from './Navigation';
import NavigationMobile from './NavigationMobile';
import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.binder(Hooks.NavigationRoot, Navigation);
ComponentUtil.binder(Hooks.NavigationMobileRoot, NavigationMobile);
